<template>
  <div>
    <h1 class="uppercase pl-6 text-gray-500 pb-3 font-semibold">
      {{$t('messages.message')}}
    </h1>
    <div class="flex justify-start pb-4">
      <div class="flex border-b border-gray-200 w-full px-3">
        <button
          @click="currentTabComponent='ReceivedMessages'"
          :class="buttonStyle('ReceivedMessages')"
          class="text-sm lg:text-base tracking-wider text-left p-3 uppercase font-light pl-4">
          {{$t('messages.received')}}
        </button>
        <button
          @click="currentTabComponent='SentMessages'" :class="buttonStyle('SentMessages')"
          class="text-sm lg:text-base tracking-wider text-left p-3 uppercase font-light">
          {{$t('messages.sent')}}
        </button>
      </div>
      <!--<button class="w-10 h-10 rounded-full"
        :class="isTeacher ? 'bg-beige-academy-500' : 'bg-orange-academy-300'"
        @click="newMessage()">
        <span class="font-extrablack font-sans-serif text-2xl text-white">
          +
        </span>
      </button>-->
    </div>

    <keep-alive>
      <component :is="currentTabComponent" />
    </keep-alive>
    <modal resizable name="messageFormModal" />
    <v-dialog name="inviato" />
  </div>
</template>

<script>
import ReceivedMessages from '@/components/ReceivedMessages.vue';
import SentMessages from '@/components/SentMessages.vue';
import MessageForm from '@/components/modals/MessageForm.vue';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      currentTabComponent: 'ReceivedMessages',
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
    }),
  },

  components: {
    ReceivedMessages,
    SentMessages,
  },

  methods: {
    buttonStyle(value) {
      if (value === this.currentTabComponent) return 'border-orange-academy-300 text-orange-academy-300 whitespace-nowrap border-b-2';
      return 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2';
    },

    newMessage() {
      this.$modal.show(
        MessageForm, { fromUser: this.user, toUser: '' },
        { adaptive: true, draggable: true },
      );
    },
  },
};
</script>
